import {Box, DialogActions, Typography} from '@mui/material';
import Button from 'components/Button';
import {PrimaryButton} from 'components/buttons/PrimaryButton';
import Dialog from 'components/Dialog';
import Panel from 'components/Panel';
import ReferenceItems from 'features/layout/CommonPage/panels/ReferencesPanel/ReferenceItems';
import {pageSelectors} from 'features/layout/CommonPage/redux';
import {isEmpty} from 'lodash';
import React, {memo} from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';

export type PendingChangesDialogData = {
   title?: string;
   processLabel?: string;
   confirmLabel?: string;
   cancelLabel?: string;
};
type Props = {
   onClose: (status?: boolean) => void;
   data?: PendingChangesDialogData;
};
const PendingChangesDialog = memo(({onClose, data}: Props) => {
   const {t} = useTranslation();
   const {
      title = t('Unsaved Changes'),
      confirmLabel = t('Ok'),
      cancelLabel = t('Cancel'),
      processLabel = t('continue'),
   } = data || {};
   const {transactions, partners, sftpUsers} = useSelector(
      pageSelectors.getPendingPartnersTransactions
   );

   return (
      <Dialog header={title} close={onClose}>
         <Typography variant={'body2'}>
            {!isEmpty(transactions)
               ? t('There are Transactions with unsaved changes.')
               : t('There are items with unsaved changes.')}
         </Typography>
         <Typography variant={'body2'}>
            {t('Those changes will be lost if you {{processLabel}} now.', {processLabel})}
         </Typography>
         <Box paddingTop={2}>
            <Panel name={t('Unsaved Items')}>
               {!isEmpty(partners) ? (
                  <ReferenceItems
                     name={`${t('Unsaved Partners')}`}
                     data={partners}
                     noData={t('<No Partners>')}
                  />
               ) : null}
               {!isEmpty(transactions) ? (
                  <ReferenceItems
                     name={`${t('Unsaved Transactions')}`}
                     data={transactions}
                     noData={t('<No Transactions>')}
                  />
               ) : null}
               {!isEmpty(sftpUsers) ? (
                  <ReferenceItems
                     name={`${t('Unsaved File Transfer Users')}`}
                     data={sftpUsers}
                     noData={t('<No File Transfer Users>')}
                  />
               ) : null}
            </Panel>
         </Box>

         <DialogActions>
            <PrimaryButton autoFocus onClick={() => onClose(true)}>
               {confirmLabel}
            </PrimaryButton>
            <Button onClick={() => onClose(false)}>{cancelLabel}</Button>
         </DialogActions>
      </Dialog>
   );
});

export default PendingChangesDialog;
